module.exports = __webpack_public_path__ + "img/dave-daragh.8f6f80d.webp";